module.exports = __webpack_public_path__ + "img/iconLiang.9b7229ae.png";